import { render, staticRenderFns } from "./sh_valuation.vue?vue&type=template&id=0cb87647&scoped=true"
import script from "./sh_valuation.vue?vue&type=script&lang=js"
export * from "./sh_valuation.vue?vue&type=script&lang=js"
import style0 from "./sh_valuation.vue?vue&type=style&index=0&id=0cb87647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb87647",
  null
  
)

export default component.exports